import React from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Application, ApplicationQuickMetrics, AppIcon } from "../../../..";
import { LoadingState, LoadingDisplay, appPaths } from "../../../../../Common";
import AppSummaryGridItem from "./AppSummaryGridItem";
import styles from "../../../../Styles/AppSummaryGridItemContainer.module.scss";

type Props = {
  app: Application;
  metrics: ApplicationQuickMetrics;
  loadingState: LoadingState;
};

export default class AppSummaryGridItemContainer extends React.Component<Props> {
  render() {
    const appLink = appPaths.app.featureRequests.replace(":id", this.props.app.rolePrefix);
    return (
      <Link
        to={appLink}
        className={styles.appSummaryGridItemContainer}
        title={`Click here to view the Feedback submitted for the ${this.props.app.name} app`}
      >
        <Row>
          <Col sm={3}>
            <AppIcon appRolePrefix={this.props.app.rolePrefix} className={styles.appIcon} />
          </Col>
          <Col sm={9} className={styles.appNameCol}>
            <h4>{this.props.app.name}</h4>
          </Col>
        </Row>
        {this.props.loadingState.isLoading && <LoadingDisplay />}
        {this.props.loadingState.isLoaded && <AppSummaryGridItem metrics={this.props.metrics} />}
      </Link>
    );
  }
}
